import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

const faqs = [
  {
    q: "What does Zenia manage end to end",
    a: "Zenia manages pricing, listings, guest communication, housekeeping coordination, maintenance and owner reporting through structured operational systems.",
  },
  {
    q: "Do you guarantee income or occupancy",
    a: "No. Zenia does not guarantee income or occupancy. Our focus is disciplined execution, pricing optimisation and long term performance.",
  },
  {
    q: "How is pricing determined",
    a: "Pricing responds to demand patterns, seasonality, booking history and local competitive data.",
  },
  {
    q: "How often do owners receive reports",
    a: "Owners receive periodic reports covering revenue, occupancy, pricing performance and operational insights.",
  },
  {
    q: "Can owners remain involved",
    a: "Yes. Owners can remain informed or hands off depending on their preference.",
  },
  {
    q: "Which markets does Zenia operate in",
    a: "Zenia operates in selected high demand markets supported by local operations.",
  },
];

export default function FaqSection() {

  const [openIndex, setOpenIndex] = useState(0);

  return (

    <Section background="bg-brand-secondary" padding="md">

      <Container>

        <div className="grid gap-14 lg:grid-cols-2 items-center">

          {/* LEFT COPY */}

          <div className="max-w-content">

            <span className="text-small font-semibold uppercase tracking-wide text-white/70">
              Frequently asked questions
            </span>

            <h3
              className="
              mt-5
              text-display
              font-extrabold
              leading-tight
              text-white
              max-w-[18ch]
              "
            >
              Clear answers you can trust
            </h3>

            <p className="mt-6 text-body leading-relaxed text-white/80 max-w-reading">
              Zenia believes trust grows through clarity. These are the most
              common questions owners ask before partnering with us.
            </p>

            <a
              href="/contact"
              className="
              mt-8
              inline-flex
              items-center
              gap-2
              text-body
              font-semibold
              text-white
              hover:opacity-80
              transition
              "
            >
              Talk to our team
              <span className="text-title">↗</span>
            </a>

          </div>


          {/* RIGHT ACCORDION */}

          <div className="rounded-xl bg-bg-surface p-6 md:p-8 shadow-card">

            <ul className="divide-y border-soft">

              {faqs.map((item, i) => {

                const open = i === openIndex;

                return (

                  <li key={i}>

                    <button
                      onClick={() => setOpenIndex(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-6 py-5 text-left"
                    >

                      <span className="text-body font-semibold text-text-primary">
                        {item.q}
                      </span>

                      <span className="text-title font-medium text-text-muted">
                        {open ? "−" : "+"}
                      </span>

                    </button>

                    <AnimatePresence initial={false}>

                      {open && (

                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.35, ease: "easeOut" }}
                        >

                          <p className="pb-5 pr-8 text-body leading-relaxed text-text-muted">
                            {item.a}
                          </p>

                        </motion.div>

                      )}

                    </AnimatePresence>

                  </li>

                );

              })}

            </ul>

          </div>

        </div>

      </Container>

    </Section>

  );
}